// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"ea40be17","545":"e4efc232","591":"3538adf7"}[chunkId] + ".chunk.js";
};